import { Moment } from 'moment';
import { Dto } from '@core/data/dto/dto';
import { DtoForceConstructor, DtoImport, DtoExport } from '@core/utils/dto';
import { LeavePolicySchema } from './leave-policy.schema';
import { DtoType } from '@core/data/dto/dto-types';
import { DTO_DEFAULT } from '@core/data/dto/dto-types';
import { Entity } from '@core/data/dto/entity';
import { ListItem } from '../common/list-item';
import { ListGroupBy } from '../common/list-group-by';
import { ListSortBy } from '../common/list-sort-by';
import { BalanceResetType } from './balance-reset-type';
import { LeavePolicySubType } from './leave-policy-sub-type';

@DtoForceConstructor
export class LeavePolicy implements ListItem, Entity {
    id: string;
    name: string;
    version: number;
    type: string;
    subType: LeavePolicySubType;
    category: string;
    status: string;
    description: string;
    members: any[];
    policyDetails: any;
    policy: {
        carryoverLimit: number,
        maximumAccrual: number,
        balanceResetDate: Moment,
        balanceResetType: BalanceResetType,
        terminationPayout: boolean,
        accrualLeaveHours: number,
        accrualWorkedHours: number,
        dailyWaitingPeriod: number,
        annualLeaveHours: number;
        prorateLeaveAccrual: boolean
    };
    createdAt: Moment;
    updatedAt: Moment;
    updatedBy: string;
    public loading: boolean = false;
    public selected: boolean = false;

    @DtoImport(LeavePolicySchema)
    static import(dto: Dto): any {
        return new LeavePolicy(dto);
    }

    constructor(value?: any) {
        if (value) {

            const properties: string[] = Object.keys(value);

            properties.forEach((property: string) => {
                this[property] = value[property];
            });
        }
    }
    @DtoExport([
        {
            type: DTO_DEFAULT,
            dto: LeavePolicySchema,
        },
    ])
    export(type?: DtoType): any {}

    /**
     * Validates if this item matches the selected groups.
     * @param groupBy
     * @param selectedGroups
     * @returns {boolean}
     */
    isMatchingGroup(
        groupBy: ListGroupBy,
        selectedGroups: string[]
    ): boolean {
        const isMatched: boolean = false;
        return isMatched;
    }

    /**
     * Validates if this item matches the filter.
     * @param filterBy
     * @param filterValue
     * @returns {boolean}
     */
    isMatchingFilter(filterBy: string, filterValue: any): boolean {
        let isMatching: boolean = true;
        return isMatching;
    }

    /**
     * Returns the relevant group data for this item.
     * @param groupBy
     * @returns {string}
     */
    getGroup(groupBy?: ListGroupBy): string {
        let group: string = '';

        return group;
    }

    /**
     * Custom comparision used by sort.
     * Ref is the value to sort / compare by.
     * @param ref
     */
    valueOf(ref?: ListSortBy): any {
        return this;
    }
}
